import { Outlet } from 'react-router-dom';
import { BrandLogo } from '@/components/brand/BrandLogo';

/**
 * Layout de las pantallas públicas (login / registro).
 *
 * Existe ya en el shell para que las rutas `/login` y `/register` tengan un destino real
 * (si no, cualquier 401 que redirija a /login mostraría un 404). El formulario en sí es el
 * siguiente chat del plan (`docs/FRONTEND_PLAN.md` §4, paso 2).
 *
 * Arriba va la marca (isotipo + «SellProBot» + el lema del logo): es lo primero que ve quien
 * llega a la página principal, así que se compone con el componente de marca y no a mano.
 */
export function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-canvas px-4 py-10">
      <BrandLogo size="lg" tagline />

      <div className="w-full max-w-2xl">
        <Outlet />
      </div>

      <p className="text-micro text-ink-faint">
        Panel de administración · chatbot de ventas por WhatsApp
      </p>
    </div>
  );
}
